<template>
  <v-card max-width="500">
    <v-window v-model="currentMessage">
      <v-window-item v-for="(message, index) in messages" :key="index">
        <v-card-text>
          <span class="text-body-1">
            {{ message }}
          </span>
        </v-card-text>
      </v-window-item>
    </v-window>

    <v-divider></v-divider>

    <v-card-actions>
      <div v-if="messages.length > 1">
        <v-icon large @click="goPrevMessage">mdi-chevron-left</v-icon>
        <span class="text-body-1 grey--text text--darken-2 font-weight-medium">{{
          currentMessage + 1 + '/' + messages.length
        }}</span>
        <v-icon large @click="goNextMessage">mdi-chevron-right</v-icon>
      </div>
      <v-spacer></v-spacer>
      <v-btn color="primary" depressed @click="onOk">Ok</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'CalculatedMessages',
  components: {},
  props: {
    messages: Array,
    showCalculatedMessages: Boolean,
  },
  data() {
    return {
      currentMessage: 0,
    };
  },

  methods: {
    goNextMessage() {
      if (this.currentMessage < this.messages.length - 1) {
        this.currentMessage += 1;
      } else if (this.currentMessage === this.messages.length - 1) {
        this.currentMessage = 0;
      }
    },

    goPrevMessage() {
      if (this.currentMessage > 0) {
        this.currentMessage -= 1;
      } else if (this.currentMessage === 0) {
        this.currentMessage = this.messages.length - 1;
      }
    },

    onOk() {
      this.$emit('closeMessages');
    },
  },
};
</script>

<style></style>
